var $ = require("./..\\..\\..\\bower_components\\jquery\\dist\\jquery.js");

module.exports = function() {
	$('#sidebarBlock').toggleClass('sidebar-block');
	$('#pitchBlock').toggleClass('pitch-block');
};
